import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "styled-components";
import GlobalFonts from "./fonts";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

const theme = {
  colors: {
    green: "#A4AF55",
    lightGreen: "#DFE7AA",
    blue: "#A8C6DD",
    lightBlue: "#D7EAF8",
    coral: "#F19C6D",
    lightCoral: "#FFBE99",
    white: "#FFF",
    brown: "#AE8664",
  },
  mediaQueries: {
    tablet: "only screen and (min-width: 768px)",
    desktop: "only screen and (min-width: 1024px)",
    largeDesktop: "only screen and (min-width: 1280px)",
  },
  cubicBezier: "cubic-bezier(0.215, 0.61, 0.355, 1)",
};

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Router>
        <GlobalFonts />
        <Switch>
          <Route exact path="/">
            <App />
          </Route>
        </Switch>
      </Router>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
